/**
 * The unified /approvals inbox's tab set and its mapping onto GET
 * /api/v1/approvals/summary `by_type` keys — shared by the approvals route
 * and the Me-home "My queue" widget (a plain module, so nothing imports a
 * runtime value from a code-split route file).
 *
 * PARITY CONTRACT (wave 2): SUMMARY_KEY_BY_TAB's values must be exactly
 * the backend's approvalSummaryTypes, and every tab must have a "My queue"
 * row. The Go test TestApprovalsSummary_DashboardParity parses
 * APPROVAL_TAB_KEYS and SUMMARY_KEY_BY_TAB from THIS file (keep both flat
 * literals) and the `tab:` rows of my-open-items.tsx, and fails when the
 * badge could count work no page shows.
 */

// Every approval type the unified inbox can surface. The order here is
// the tab order; the pending-first default picks within it.
export const APPROVAL_TAB_KEYS = [
  "leave",
  "timesheet",
  "expenses",
  "wfh",
  "attendance",
  "shifts",
  "loans",
  "travel",
  "hiring",
  "change_requests",
  "reviews",
  "feedback",
  "tax_proofs",
  "resignations",
  "joiners",
] as const;

export type ApprovalsTabKey = (typeof APPROVAL_TAB_KEYS)[number];

export function isApprovalsTabKey(v: string): v is ApprovalsTabKey {
  return (APPROVAL_TAB_KEYS as readonly string[]).includes(v);
}

/** Tab key → /approvals/summary `by_type` key. */
export const SUMMARY_KEY_BY_TAB: Record<ApprovalsTabKey, string> = {
  leave: "leave",
  timesheet: "timesheet",
  expenses: "expenses",
  wfh: "wfh",
  attendance: "attendance",
  shifts: "shift_swaps",
  loans: "loans",
  travel: "travel",
  hiring: "hiring",
  change_requests: "change_requests",
  reviews: "reviews",
  feedback: "feedback",
  tax_proofs: "tax_proofs",
  resignations: "resignations",
  joiners: "joiners",
};
